const ONBOARDING_STATE_SESSION_ID_KEY = 'onboarding_state_session_id'

export const setOnboardingStateSessionId = (sessionId) => {
    sessionStorage.removeItem(ONBOARDING_STATE_SESSION_ID_KEY)
    sessionStorage.setItem(ONBOARDING_STATE_SESSION_ID_KEY, sessionId)
}

export const clearOnboardingStateSessionId = () => {
    sessionStorage.removeItem(ONBOARDING_STATE_SESSION_ID_KEY)
}

export const getOnboardingStateSessionId = () => {
    return sessionStorage.getItem(ONBOARDING_STATE_SESSION_ID_KEY)
}